import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { SITE } from "../../mock";
import { Logo } from "./Navbar";
import { XIcon, KickIcon, DiscordIcon } from "./icons";

const socialIconLinks = [
  { icon: XIcon, url: SITE.socials.x.url, label: "X / Twitter" },
  { icon: KickIcon, url: SITE.socials.kick.url, label: "Kick" },
  { icon: DiscordIcon, url: SITE.socials.discord.url, label: "Discord" },
];

const Footer = () => {
  return (
    <footer className="relative z-10 bg-[#02101f] border-t border-white/10">
      <div className="max-w-[1200px] mx-auto px-5 sm:px-8 pt-14 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="max-w-sm">
            <Logo />
            <p className="mt-5 text-[#8fb3d4] text-[0.92rem] leading-relaxed">
              Premium rewards &amp; VIP perks every day for playing on {SITE.partner.name} under the
              code “{SITE.code}”. Dive deep, wager smart, and rule the reef.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {socialIconLinks.map(({ icon: Icon, url, label }) => (
                <a
                  key={label}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-10 h-10 rounded-full bg-white/5 border border-white/15 flex items-center justify-center text-[#bcd9f2] hover:text-white hover:bg-white/10 hover:border-white/30 transition-colors duration-300"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
          <div className="flex gap-16 lg:justify-end">
            <div>
              <h4 className="text-[#cfe4fa] text-[0.72rem] font-bold tracking-[0.28em] uppercase">Site</h4>
              <ul className="mt-5 space-y-3 text-[0.92rem]">
                <li>
                  <Link to="/" className="text-[#8fb3d4] hover:text-white transition-colors duration-300">Home</Link>
                </li>
                <li>
                  <Link to="/leaderboard" className="text-[#8fb3d4] hover:text-white transition-colors duration-300">Leaderboard</Link>
                </li>
                <li>
                  <Link to="/raffles" className="text-[#8fb3d4] hover:text-white transition-colors duration-300">Raffles</Link>
                </li>
                <li>
                  <Link to="/#bonuses" className="text-[#8fb3d4] hover:text-white transition-colors duration-300">Bonus</Link>
                </li>
                <li>
                  <Link to="/#stream" className="text-[#8fb3d4] hover:text-white transition-colors duration-300">Live stream</Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="text-[#cfe4fa] text-[0.72rem] font-bold tracking-[0.28em] uppercase">Partner</h4>
              <ul className="mt-5 space-y-3 text-[0.92rem]">
                <li>
                  <a
                    href={SITE.partner.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#8fb3d4] hover:text-white transition-colors duration-300"
                  >
                    {SITE.partner.name}
                  </a>
                </li>
                <li className="text-[#5f83a6]">Code: {SITE.code}</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-7 border-t border-white/10 flex flex-col sm:flex-row sm:items-end justify-between gap-6">
          <div className="space-y-1.5">
            <p className="text-[#6f92b5] text-[0.82rem]">18+ only. Gamble responsibly. Play within your limits.</p>
            <p className="text-[#6f92b5] text-[0.82rem]">
              © {new Date().getFullYear()} {SITE.name}. All rights reserved.
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 self-start sm:self-auto px-4 py-2 rounded-full bg-white/5 border border-white/10 text-[#9fc5e8] text-[0.72rem] font-bold tracking-[0.14em]">
            made by
            <Heart className="heart-beat w-3 h-3 text-[#ff5f7a] fill-[#ff5f7a]" aria-hidden="true" />
            raff
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
